import {Helmet} from "react-helmet";
const Home = (props) => {

    return (
      <div className="container">
            <Helmet>
            <meta name="title" content="Mucksucker Router Cleaner | Industrial Swarf and Dust Vacuum Cleaner" />
              <meta name="description" content="Muck-suckers are tough, versatile vacuum units which have been specially designed to meet the needs of busy engineering, 
              industrial and commercial workshops the Mucksucker Router Cleaner easily attaches and cleans swarf and dust with ease." />
          </Helmet>


        <h1>Welcome to Mucksucker</h1>
        <div className="contentsGroup2 center">
          <h2>Router Dust Collector Vacuum</h2>
          <p>
          In 1985 Unicorn started making a lid system industrial vacuum called the MUCKSUCKER. This proved very successful in the precision engineering trade and
           since then many types have followed making the MUCKSUCKER a very adaptable, efficient and user-friendly machine, particularly with all types of routers.
          </p>

          <p>
            These tough, versatile units have been specially designed to meet the needs of busy industrial and commercial workshops. They provide a fast, cost-effective way to keep the work space clean, dust free and clear of dry waste.
          </p>

      </div>
      </div>  
    );
  };
  
  export default Home;